import React from 'react';
import { Route } from 'react-router-dom';
import InboundcallRoutes from './Inboundcall/routes';
const routes = () => [<InboundcallRoutes key="InboundcallRoutes" />];

const InboundcallRoute = () => <Route component={routes} />;

export default InboundcallRoute;



// WEBPACK FOOTER //
// src/modules/screens/inboundcall/routes.js